import { ofType, Epic } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import { get } from '__utils/ajax-wrapper';
import { FluxStandardAction } from '__utils/type';
import { ENDPOINTS } from 'constants/endpoints';
import * as Actions from 'constants/actions';
import { fetchCartDetailsSuccess, fetchCartDetailsError } from './cart.actions';
import resolveURLParams from '__utils/url-params-resolver';
import {getCartId} from "__utils/common-utils";
import { setOrgCartInfo } from '__utils/storage';

export const getCartDetailsEpic: Epic<FluxStandardAction, FluxStandardAction> = action$ => {
    return action$.pipe(
        ofType(Actions.FETCH_CART_DETAILS),
        mergeMap(() => {
            return get(resolveURLParams(ENDPOINTS.GET_CART_DETAILS, getCartId() && {  cartId: getCartId() }, null),{}, true).pipe(
                map((response: AjaxResponse | AjaxError): FluxStandardAction => {
                    if (response.status === 200) {
                        if(response.response && !getCartId())setOrgCartInfo(response.response);
                        return fetchCartDetailsSuccess(response.response);
                    } else {
                        return fetchCartDetailsError(response.response);
                    }
                }),
                catchError(error => of(fetchCartDetailsError(error)))
            );
        })
    );
};
